import { MARRIAGE_REWARD_ENABLED, REWARD_TERMS_PATH } from "../home/data/reward";

/**
 * Public policy pages, in the order they appear in the legal sidebar. `key` points at
 * legal.docs.<key> in the site translations (label, lead and last-updated date). `hidden`
 * pages keep their URL but drop out of the sidebar.
 */
export const LEGAL_DOCUMENTS = [
  { path: "/privacy", key: "privacy" },
  { path: "/your-data", key: "yourData" },
  { path: "/termsandconditions", key: "terms" },
  { path: "/communityguidelines", key: "guidelines" },
  { path: "/cookies", key: "cookies" },
  { path: "/languagepolicy", key: "language" },
  { path: "/csae", key: "csae" },
  { path: REWARD_TERMS_PATH, key: "reward", hidden: !MARRIAGE_REWARD_ENABLED },
];
